//IPAPI Singleton wrapper for library
//@author terru
//@see documentation here: https://members.ip-api.com/docs
var IPAPI = (function(ipapi) {
  let _instance = ipapi;
  const APP_KEY = "JHATxCJUlbE7xMM";
  const API_URL = "https://pro.ip-api.com/json/IP?key=" + APP_KEY;

  //testing mode vars
  const test_mode = false;
  const ip_test_CA = "24.48.0.1";
  const ip_test_EU = "176.56.238.3";

  function getInstance() {
    if (!_instance) {
      _instance = this;
    }
    return _instance;
  }

  //do a query to the api, returns a promise
  function _doquery(url) {
    return fetch(url);
  }

  //handle http error
  function _handle_error(e) {
    console.warn("Error on request..");
    console.warn(e);
  }

  async function getPosition() {
    let custom_fields = "&fields=49608"; //&fields=status,message,regionName,lat,lon,timezone"
    //IP must be empty to get the user IP
    let url = API_URL.replace("IP", "") + custom_fields;
    let position = {};
    try {
      let response = await _doquery(url);
      position = await response.json();
      return position;
    } catch (e) {
      _handle_error(e);
      return position;
    }
  }

  async function getUserLocation() {
    //each feature returns an specific set of fields
    let custom_fields = "&fields=3194927";
    //"&fields=status,message,continentCode,country,countryCode,region,regionName,city,zip";

    let url = API_URL + custom_fields;
    let location = {};

    if (test_mode) {
      console.log("WARNING, running in test mode....");
      url = url.replace("IP", ip_test_CA);
    } else {
      //IP must be empty to get the user IP
      url = url.replace("IP", "");
    }

    try {
      let response = await _doquery(url);
      location = await response.json();
      return location;
    } catch (e) {
      _handle_error(e);
      return location;
    }
  }

  return {
    getInstance: getInstance,
    getPosition: getPosition,
    getUserLocation: getUserLocation
  };
})(navigator.ipapi);

//@usage
// if (IPAPI.getInstance()) {
//   IPAPI.getPosition().then(function(position) {
//     console.log(`this position: ${position}`);
//   });
// } else {
//   console.log("IPAPI is not supported for this Browser/OS.");
// }
